import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const PreviewIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        fill: "none",
        stroke: "currentColor",
      }}
      viewBox="0 0 24 24"
    >
      <path
        d="M18.1797 10.5V19.125C18.1797 19.3712 18.1312 19.615 18.037 19.8425C17.9427 20.07 17.8046 20.2767 17.6305 20.4508C17.4564 20.6249 17.2497 20.763 17.0222 20.8573C16.7947 20.9515 16.5509 21 16.3047 21H5.05469C4.55741 21 4.08049 20.8025 3.72886 20.4508C3.37723 20.0992 3.17969 19.6223 3.17969 19.125V7.875C3.17969 7.37772 3.37723 6.90081 3.72886 6.54917C4.08049 6.19754 4.55741 6 5.05469 6H12.9053M15.9297 3H21.1797V8.25M10.6797 13.5L20.8047 3.375"
        // stroke=""
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default PreviewIcon;
